import { PanelMenuDesignTokens } from "@primevue/themes/aura/panelmenu"
import { PanelMenuPassThroughOptionType } from "primevue"

export const panelMenuConfig = (): PanelMenuDesignTokens => {
  return {
    root: {

    },
    panel: {
      background: 'transparent',
      borderColor: 'transparent',
    },
    item: {
      color: '#595c97'
    }
  }
}

export const panelMenuPt = (): PanelMenuPassThroughOptionType => {
  return {

  }
}
